import { Outlet, useLocation } from "react-router-dom";
import { Header } from "../Components/Header";
import { COCKPIT_ROUTES } from "../Components/Cockpit/cockpitMarkets";

/** The two collectible card routes render their own Pokédex device header. */
const COCKPIT_PATHS = Object.values(COCKPIT_ROUTES);

export const MainLayouts = () => {
  const location = useLocation();

  // Only these two routes swap the header; every other page is untouched.
  const isCockpitRoute = COCKPIT_PATHS.includes(location.pathname);

  return (
    <div className="flex flex-col w-full h-full">
      {!isCockpitRoute && <Header />}
      <Outlet />
    </div>
  );
};
